// Erros do fluxo OIDC que não são instabilidade: pedem um login novo.
//
// - `login_required`, `interaction_required`, `consent_required` e
//   `account_selection_required` voltam do IdS quando a renovação silenciosa
//   (prompt=none) não consegue emitir token sem o usuário. É o esperado depois
//   que a sessão do IdS vence.
// - As mensagens abaixo são lançadas pelo oidc-client quando o `state` da
//   resposta não existe (URL sem state) ou não bate com nenhuma chave `oidc.*`
//   do storage (estado órfão ou já consumido).
export const ERROS_QUE_EXIGEM_NOVO_LOGIN = [
  "login_required",
  "interaction_required",
  "consent_required",
  "account_selection_required"
];

export const MENSAGENS_DE_ESTADO_INVALIDO = [
  "No matching state found in storage",
  "No state in response"
];

const obterMensagem = erro => {
  if (!erro) return "";
  if (typeof erro === "string") return erro;
  return erro.message || "";
};

export const exigeNovoLogin = erro => {
  if (!erro) return false;

  if (
    typeof erro === "object" &&
    ERROS_QUE_EXIGEM_NOVO_LOGIN.includes(erro.error)
  ) {
    return true;
  }

  const mensagem = obterMensagem(erro);
  return (
    ERROS_QUE_EXIGEM_NOVO_LOGIN.includes(mensagem) ||
    MENSAGENS_DE_ESTADO_INVALIDO.some(texto => mensagem.includes(texto))
  );
};

// O state da resposta não bate com nenhum `oidc.*` do storage. Acontece, por
// exemplo, quando o callback é reaberto depois de já ter sido consumido.
export const ehEstadoOrfao = erro =>
  obterMensagem(erro).includes("No matching state found in storage");
